import { useAuth } from "../../../usercontext";
import GlobalStudentActivityReportList from "../../pages/common/globalstudentactivityreportlist";
import STopMenu from "../../../components/student/topmenu/topmenu";
import S911TopMenu from "../../student911/topmenu/topmenu";
import S12TopMenu from "../../student12/topmenu/topmenu";
export default function StudentActivityReportList() {
  const { profile } = useAuth();
  const slug = profile.id;
  const isStudent911 = profile?.role === "Student911";
  const isStudent12 = profile?.role === "Student12";
  const isStudent = profile?.role === "Student";
  return (
		<>
			{isStudent && <STopMenu slug={slug} activeMenu='Activity Reports' />}
			{isStudent911 && <S911TopMenu slug={slug} activeMenu='Activity Reports' />}
			{isStudent12 && <S12TopMenu slug={slug} activeMenu='Activity Reports' />}
			<GlobalStudentActivityReportList
				studentId={slug}
				isStudent={true}
				studentRole={profile?.role}
			/>
		</>
  );
}
